import React, { useCallback, useEffect, useState } from 'react';
import { get } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { Icon } from '@doxyme/ui';
import { getToasts } from '../../selectors/toasts';
import { removeToast } from '../../actions/toasts';
import { RawHTML } from '../raw-html';
const FADE_ANIMATION_TIME = 300; // ms
// now this component just uses styles (by using same class names) from angular notifications
// todo: rewrite it with custom styles or another library after migration
export const GlobalNotifications = () => {
    const dispatch = useDispatch();
    const intl = useIntl();
    const toasts = useSelector(getToasts);
    const dismissLabel = intl.formatMessage({ id: 'notification.dismiss' });
    const close = useCallback((toast) => dispatch(removeToast(toast.id)), [dispatch]);
    const onNotificationClick = useCallback(
    // do we need this 'if', maybe just to close on any click?
    (e, toast) => Boolean(get(e, 'nativeEvent.target.dataset.notificationClose')) &&
        close(toast), [close]);
    // hack to have same behavior as in angular - fade out last notification
    // when not needed - remove below block of code and use 'toasts' in render
    const [toastsToDisplay, setToastsToDisplay] = useState([]);
    useEffect(() => {
        const timer = setTimeout(() => setToastsToDisplay(toasts), toasts.length === 0 ? FADE_ANIMATION_TIME : 0);
        return () => clearTimeout(timer);
    }, [toasts]);
    const containerClassName = classnames('notifications-container', toastsToDisplay.length === 0 && 'is-empty', toasts.length === 0 && 'js-st-instance');
    return (<div className="notifications">
      <div className={containerClassName}>
        {toastsToDisplay.map((toast) => (<div key={toast.id} className={toast.type} role="alert" onClick={(e) => onNotificationClick(e, toast)}>
            <RawHTML className="message">{toast.message}</RawHTML>
            <button type="button" className="notification-close" aria-label={dismissLabel} onClick={() => close(toast)}>
              <Icon className="icon" name="close" size="x-small"/>
            </button>
          </div>))}
      </div>
    </div>);
};
export default GlobalNotifications;
